import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText, Icon, Container, TitleText, useResponsive } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const HomeLoyaltyCard = (props: HomeLoyaltyCardProps) => {
  const { title, description, cta, onPress } = props;
  const { match } = useResponsive();

  // ───────────────────────────────────────────────────────────────────────────

  const Wrapper = match([Container, View]);

  return (
    <Wrapper style={match([styles.containerXS, styles.containerSM])}>
      <Pressable accessibilityRole="link" aria-label={cta} style={styles.card} onPress={onPress}>
        <View style={styles.content}>
          <View style={styles.info}>
            <TitleText sizeMatch={['18']} style={styles.title}>
              {title}
            </TitleText>

            <BodyText sizeMatch={['12']} style={styles.description}>
              {description}
            </BodyText>
          </View>

          <View style={styles.iconWrapper}>
            <Icon name="IconSgRewardSweetCornOutline" width={24} height={24} />

            <BodyText sizeMatch={['14']} style={styles.cta}>
              {cta}
            </BodyText>
          </View>
        </View>
      </Pressable>
    </Wrapper>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerXS: {
    paddingHorizontal: theme.spacing['4'],
  },
  containerSM: {
    minWidth: 343,
    maxWidth: '100%',
  },
  card: {
    padding: theme.spacing['6'],
    borderRadius: theme.radius.xlarge,
    backgroundColor: theme.colors.FOREST,
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing['4'],
  },
  info: {
    flex: 1,
    gap: theme.spacing['2'],
  },
  title: {
    color: theme.colors.WHITE,
  },
  cta: {
    color: theme.colors.WHITE,
  },
  description: {
    color: theme.colors.OPACITY.WHITE.DARKEST,
  },
  iconWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing['2'],
    borderWidth: 1,
    borderColor: theme.colors.WHITE,
    borderRadius: theme.radius.xlarge,
    paddingHorizontal: theme.spacing['4'],
    paddingVertical: theme.spacing['2'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type HomeLoyaltyCardProps = {
  title: string;
  description: string;
  cta: string;
  onPress: () => void;
};
